import { CardProps } from "@mui/material";
import {
  OverviewTableCell,
  OverviewTableCellBody,
  OverviewTableCellHeader,
} from "@pimo/pimo-components";
import { FC } from "react";
import { StatusDefinition } from "vmd-types";

import { Badge } from "./badge";

export type BadgeCellProps = {
  body?: string;
  header?: string;
  definitions?: StatusDefinition[];
  color?: string;
  textColor?: string;
  /** Pins the badge to the start or end of the cell, whatever alignment the column inherits. */
  align?: "left" | "right";
  /** PMTable passes `{ sx: { padding: 0 } }` here; without it the cell keeps its own 20px inset and the badge sits right of the neighbouring columns. */
  cardProps?: CardProps;
};

/** Table cell wrapping Badge, matching the layout/chrome of the other overview-table cells. */
export const BadgeCell: FC<BadgeCellProps> = ({
  body,
  header,
  definitions,
  color,
  textColor,
  align,
  cardProps = {},
}) => (
  <OverviewTableCell {...cardProps} sx={{ ...cardProps.sx }}>
    {header && <OverviewTableCellHeader>{header}</OverviewTableCellHeader>}
    <OverviewTableCellBody
      sx={{
        overflow: "unset",
        height: "1.5em",
        ...(align && {
          display: "flex",
          alignItems: "center",
          justifyContent: align === "left" ? "flex-start" : "flex-end",
          textAlign: align,
        }),
      }}
    >
      <Badge
        value={body}
        definitions={definitions}
        color={color}
        textColor={textColor}
      />
    </OverviewTableCellBody>
  </OverviewTableCell>
);
